import { render, staticRenderFns } from "./ChannableGoogleAdsCampaign.vue?vue&type=template&id=ada7ba7a"
import script from "./ChannableGoogleAdsCampaign.vue?vue&type=script&lang=js"
export * from "./ChannableGoogleAdsCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports